import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  icon = 'TrendingUp',
  label = '',
  value = '',
  trend = null,
  trendLabel = '',
  color = 'primary'
}) => {
  const colorConfig = {
    primary: {
      icon: 'text-primary',
      bg: 'bg-primary/10'
    },
    success: {
      icon: 'text-success',
      bg: 'bg-success/10'
    },
    warning: {
      icon: 'text-warning',
      bg: 'bg-warning/10'
    },
    accent: {
      icon: 'text-accent',
      bg: 'bg-accent/10'
    }
  };

  const config = colorConfig?.[color] || colorConfig?.primary;

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className={`p-2 md:p-3 rounded-lg ${config?.bg}`}>
          <Icon name={icon} size={20} className={config?.icon} />
        </div>
        {trend !== null && (
          <div className={`flex items-center gap-1 ${trend >= 0 ? 'text-success' : 'text-error'}`}>
            <Icon name={trend >= 0 ? 'TrendingUp' : 'TrendingDown'} size={16} />
            <span className="text-xs md:text-sm font-body font-medium">
              {Math.abs(trend)}%
            </span>
          </div>
        )}
      </div>
      <div className="space-y-1">
        <p className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
          {value}
        </p>
        <p className="text-xs md:text-sm caption text-muted-foreground">
          {label}
        </p>
        {trendLabel && (
          <p className="text-xs caption text-muted-foreground">
            {trendLabel}
          </p>
        )}
      </div>
    </div>
  );
};

export default MetricCard;